import cloneDeep_1 from '../node_modules/lodash/cloneDeep.js';
import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func clone
 * @param {object} object - the object to clone.
 * @return {object}
 * @desc Returns a deep clone of the object (free from references)
 * ```js
 * clone({ name: 'Ozzie' });
 * // returns { name: 'Ozzie' }
 * ```
 * @memberof module:Object
 * @instance
 */
function clone(object) {
    if (!checkTypeValidity(['object'], object))
        return object;
    return cloneDeep_1(object);
}

export { clone as default };
